export const asFormattedString = (value) => {
    return (typeof value === 'number' && !isNaN(value)) || value
        ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        : '';
};
export const getCacheBusterNumber = (min, max) => Math.floor(Math.random() * (max - min)) + min;
export const getRandomInteger = (min, max) => {
    const minSafe = min === Number.NEGATIVE_INFINITY || Number.isNaN(min) ? Number.MIN_SAFE_INTEGER : min;
    let maxSafe = max === Number.POSITIVE_INFINITY || Number.isNaN(max) ? Number.MAX_SAFE_INTEGER : max;
    if (minSafe > maxSafe) {
        maxSafe = Number.MAX_SAFE_INTEGER;
    }
    return Math.floor(Math.random() * (maxSafe - minSafe) + minSafe);
};
export const stripNonDigits = (value) => (value && value.replace(/[^\d]+/g, '')) || '';
export const formattedPriceString = (value, plusVat = false, currency = '£') => plusVat ? `${currency}${asFormattedString(value)} +VAT` : `${currency}${asFormattedString(value)}`;
export const formattedPrice = (value) => {
    const isNegativeValue = value < 0;
    const prefix = isNegativeValue ? '-£' : '£';
    const positiveValue = isNegativeValue ? Math.abs(value) : value;
    return `${prefix}${asFormattedString(positiveValue.toFixed(2))}`;
};
export const truncatedZeroPencePrice = (value, plusVat = false) => {
    const price = formattedPrice(value);
    const truncatedPrice = price.endsWith('.00') ? price.substring(0, price.length - 3) : price;
    return plusVat ? `${truncatedPrice} +VAT` : truncatedPrice;
};
export const countDecimals = (value) => Math.floor(value) === value ? 0 : value.toString().split('.')[1].length;
export const percentageValue = (value, decimalPlaces = 2) => {
    const percentage = countDecimals(value) < decimalPlaces ? value : value.toFixed(decimalPlaces);
    return `${percentage}%`;
};
export const oneDecimalPlace = (value) => Number(value).toFixed(1);
export const unformattedPrice = (price) => {
    return parseInt(price.replace('£', '').replace(',', ''));
};
export const roundedOverallRating = (rating) => {
    return Math.round(rating / 0.2) / 10;
};
export const roundAndFormatPriceAsString = (price) => {
    const roundedPrice = Math.ceil(price);
    return truncatedZeroPencePrice(roundedPrice);
};
